__webpack_require__.O(0, ["onfido"], function() {
	__webpack_require__.E("activeVideo");
}, 5);